
import React from 'react';
import PropTypes from 'prop-types';


import AnnotationOptions from '../../../components/common/AnnotationOptions';
import ImageUploadControl from './ImageUploadControl';

const ImageControls = ({ image, saveImage, children = null, t }) => (
  <AnnotationOptions
    className="respark_image-tool-options"
    annotation={image}
    updateAnnotation={saveImage}
    t={t}
    hideFillOption
  >
    <ImageUploadControl t={t} />
    {children}
  </AnnotationOptions>
);


ImageControls.propTypes = {
  image: PropTypes.instanceOf(Object).isRequired,
  saveImage: PropTypes.func.isRequired,
  children: PropTypes.node,
  t: PropTypes.func.isRequired,
};

export default ImageControls;
